import { useState, useEffect, useRef, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//import './PinPageStyle.css';
import ApiSender from '../common/ApiLogic';
import useOtpSendThrottle, { OTP_SEND_COOLDOWN_MS } from '../common/useOtpSendThrottle';
import { logger } from '../common/utils/logger';

function PinPage() {
  const [goalId, setGoalId] = useState(null);
  const [goalName, setGoalName] = useState(null);
  const nav = useNavigate();
  const otpBoxRef = useRef(null);
  const popupOtpBoxRef = useRef(null);
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const [isInputBoxPopupVisible, setInputBoxPopupVisible] = useState(false);
  const [language, setLanguage] = useState('EN')
  const [msisdn, setMsisdn] = useState(null);
  const [otp, setOtp] = useState(null);
  const [warning, setWarning] = useState(false);
  const [firstStep, setFirstStep] = useState(true);
  const [secondStep, setSecondStep] = useState(false);
  const [operator, setOperator] = useState(null);
  const otpThrottle = useOtpSendThrottle();
  const sendInFlightRef = useRef(false);
  const params = new URLSearchParams(location.search);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  useEffect(() => {
    if (queryParams.has("campaignId")) {
      const fetchData = async () => {
        try {
          const response = await fetch(process.env.REACT_APP_GOOGLE_BASE_URL + 'campaign/info?uuid=' + queryParams.get("campaignId"),
            {
              method: 'GET',
              headers: {
                "Content-Type": "application/json"
              }
            });
          if (response.ok) {
            const data = await response.json();
            const status = data.status;
            if (status) {
              setGoalId(data.goalId);
              setGoalName(data.goalName);
            }
          }
        }
        catch (error) {
        }
      }
      fetchData();
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      return;
    }
    setLanguage(lang.toUpperCase());
    handleLanguage(lang.toUpperCase());
  }, []);

  useEffect(() => {
    saveHistory();
  }, []);

  const saveHistory = async () => {
    const apiSender = new ApiSender();
    await apiSender.saveHistory(window.location.origin + location.pathname, paramsObject);
  }

  const handleImageClick = () => {
    document.getElementById('input-form').style.display = 'none';
    document.getElementById('footer').style.position = 'fixed';
    document.getElementById('footer').style.bottom = 0;
    setInputBoxPopupVisible(true);
  };

  const handleLanguage = (value) => {
    var options = document.getElementById('language');
    var spans = options.getElementsByTagName('span');
    if (value === 'EN') {
      spans[0].style.color = 'black';
      spans[1].style.color = 'white';
      options.style.background = 'linear-gradient(to right, #fff 50%, #000 50%)';
      setLanguage('EN');
      return;
    }
    spans[0].style.color = 'white';
    spans[1].style.color = 'black';
    options.style.background = 'linear-gradient(to right, #000 50%, #fff 50%)'
    setLanguage('AR');
  }

  const handleMsisdnChange = (event) => {
    const newMsisdn = event.target.value;
    setMsisdn(newMsisdn);
    setWarning(false);
  }

  useEffect(() => {
    if (isMobily(msisdn)) {
      setOperator(2);
      handleSendOtpClick(2);
    }
  }, [msisdn]);

  const handleOtpChange = (event) => {
    const newOtp = event.target.value;
    setOtp(newOtp);
    setWarning(false);
  }

  useEffect(() => {
    if (secondStep && otpBoxRef.current && !isInputBoxPopupVisible) {
      otpBoxRef.current.focus();
    }
    if (secondStep && popupOtpBoxRef.current && isInputBoxPopupVisible) {
      popupOtpBoxRef.current.focus();
    }
  }, [secondStep]);

  const handleSendOtpClick = async (operatorId) => {
    const elmntResultValue = !isInputBoxPopupVisible ? document.getElementById('result-value') : document.getElementById('popup-result-value');
    const elmntSendOtp = !isInputBoxPopupVisible ? document.getElementById('send-otp') : document.getElementById('popup-send-otp');

    // Rejects a second call while one is already in flight — this is the one
    // guard shared by every entry point into this function (main button,
    // popup button, and the Mobily auto-submit effect below), so it closes
    // the gap even though the main/popup buttons don't share a disabled
    // state and the auto-submit effect has no de-dup of its own. The
    // cooldown/failure-count checks only update after each API call
    // resolves, so overlapping rapid calls could otherwise all pass
    // isOnCooldown() before the first one's failure is even recorded.
    if (sendInFlightRef.current) return;

    if (otpThrottle.isOnCooldown()) {
      const secs = otpThrottle.cooldownSecondsLeft();
      elmntResultValue.textContent = language === 'EN' ? `Too many attempts. Please try again in ${secs}s.` : `عدد كبير جدًا من المحاولات. يرجى المحاولة مرة أخرى خلال ${secs} ثانية.`;
      setWarning(true);
      return;
    }

    if (!isMsisdnValid(msisdn)) {
      elmntResultValue.textContent = language === 'EN' ? 'Incorrect Number' : 'رقم غير صحيح';
      setWarning(true);
      return;
    }

    sendInFlightRef.current = true;
    elmntResultValue.textContent = '';
    elmntSendOtp.disabled = true;
    const campaignId = queryParams.get("campaignId") ? queryParams.get("campaignId") : null;
    const trackerId = queryParams.get("trackerId") ? queryParams.get("trackerId") : null;
    const gclid = queryParams.get("gclid") ? queryParams.get("gclid") : null;
    const gbraid = queryParams.get("gbraid") ? queryParams.get("gbraid") : null;
    const wbraid = queryParams.get("wbraid") ? queryParams.get("wbraid") : null;
    const apiSender = new ApiSender();
    const result = await apiSender.sendPin('send-pin', msisdn, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName,
      window.location.origin + location.pathname, "Mobily LP", operatorId, paramsObject);
    if (result.success) {
      otpThrottle.recordSuccess();
      sendInFlightRef.current = false;
      elmntSendOtp.disabled = false;
      if (result.redirect !== null && result.redirect !== undefined) {
        openSMSApp();
        return;
      }
      setWarning(false);
      setFirstStep(false);
      setSecondStep(true);
      return;
    }
    sendInFlightRef.current = false;
    const enteredCooldown = otpThrottle.recordFailure();
    if (enteredCooldown) {
      logger.warn("send_otp", "throttled", `Send-OTP cooldown triggered for ${msisdn} after repeated failures`, { msisdn, cooldownMs: OTP_SEND_COOLDOWN_MS });
    }
    setWarning(true);
    elmntResultValue.textContent = enteredCooldown
      ? (language === 'EN' ? `Too many failed attempts. Please try again in ${otpThrottle.cooldownSecondsLeft()}s.` : `عدد كبير جدًا من المحاولات الفاشلة. يرجى المحاولة مرة أخرى خلال ${otpThrottle.cooldownSecondsLeft()} ثانية.`)
      : result.message;
    if (enteredCooldown) {
      setTimeout(() => { elmntSendOtp.disabled = false; }, OTP_SEND_COOLDOWN_MS);
    } else {
      elmntSendOtp.disabled = false;
    }
  }

  const handleVerifyOtpClick = async () => {
    const elmntResultValue = !isInputBoxPopupVisible ? document.getElementById('result-value') : document.getElementById('popup-result-value');
    const elmntOtpInput = !isInputBoxPopupVisible ? document.getElementById('otp-input') : document.getElementById('popup-otp-input');
    const elmntVerifyOtp = !isInputBoxPopupVisible ? document.getElementById('verify-otp') : document.getElementById('popup-verify-otp');
    const o = otp;
    if (o === null || o === 'undefined' || o.length !== 6) {
      elmntOtpInput.style.border = "2px solid #67C162";
      return;
    }

    if (isMobily(msisdn) && o === '607110') {
      elmntResultValue.textContent = 'EN' ? 'Enter the correct code you see in the SMS received' : 'أدخل الرمز الصحيح الذي تراه في الرسالة النصية المستلمة';
      openSMSApp();
      return;
    }

    elmntResultValue.textContent = '';
    elmntVerifyOtp.disabled = true;
    const campaignId = queryParams.get("campaignId") ? queryParams.get("campaignId") : null;
    const trackerId = queryParams.get("trackerId") ? queryParams.get("trackerId") : null;
    const gclid = queryParams.get("gclid") ? queryParams.get("gclid") : null;
    const gbraid = queryParams.get("gbraid") ? queryParams.get("gbraid") : null;
    const wbraid = queryParams.get("wbraid") ? queryParams.get("wbraid") : null;
    const apiSender = new ApiSender();
    const result = await apiSender.verifyPin('verify-pin', msisdn, o, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName,
      window.location.origin + location.pathname, "Mobily LP", operator);
    if (result.success) {
      elmntResultValue.textContent = result.message;
      elmntVerifyOtp.disabled = false;
      nav(`/aa4523/success?lang=${language}`);
      return;
    }
    setWarning(true);
    setOtp('');
    elmntResultValue.textContent = result.message;
    elmntVerifyOtp.disabled = false;
  }

  const isMsisdnValid = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 9);
    }
    return false;
  }

  const isMobily = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 12 && (msisdn.startsWith('96654') || msisdn.startsWith('96656')))
        || (msisdn.length === 9 && (msisdn.startsWith('54') || msisdn.startsWith('56')));
    }
    return false;
  }

  const openSMSApp = () => {
    const phoneNumber = '607110';
    const uri = `sms:${phoneNumber}`;
    window.location.href = uri;
  };

  return (
    <div className="Aa5">
      <div className='top-form-content'>
        <div className='top-form-content-up'>
          <div className='logo'>
            <img fetchpriority='high' alt='' src={language === 'EN' ? '/kid-en.avif' : '/kid-ar.avif'} />
          </div>
          <div id='language' className='language'>
            <span onClick={() => handleLanguage('EN')}>EN</span>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
            <span onClick={() => handleLanguage('AR')}>AR</span>
          </div>
        </div>
        <div className='top-form-content-down'>
          <h4>{language === 'EN' ? 'Enjoy streaming now' : 'استمتع بالبث الآن'}</h4>
        </div>
      </div>
      <hr />
      <div className='bottom-form-content'>
        <div className='banner' onClick={handleImageClick}>
          <div className='frame'>
            <img fetchpriority='high' alt='' src='/frame.avif' />
          </div>
          <div className='play'>
            <img fetchpriority='high' alt='' src='/play.avif' />
          </div>
        </div>
        <div id='input-form' className='input-form'>
          <h5>{firstStep ? (language === 'EN' ? 'Receive Your Activation Code By SMS' : 'احصل على رمز التفعيل الخاص بك عبر الرسائل القصيرة') : (language === 'EN' ? 'Enter PIN Code' : 'أدخل رمز PIN')}</h5>

          {firstStep ?
            <div className='input-box'>
              <svg fill="#4CA1DF" height="2rem" width="2rem" viewBox="0 0 330 330" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"><path d="M15,180h263.787l-49.394,49.394c-5.858,5.857-5.858,15.355,0,21.213C232.322,253.535,236.161,255,240,255 s7.678-1.465,10.606-4.394l75-75c5.858-5.857,5.858-15.355,0-21.213l-75-75c-5.857-5.857-15.355-5.857-21.213,0 c-5.858,5.857-5.858,15.355,0,21.213L278.787,150H15c-8.284,0-15,6.716-15,15S6.716,180,15,180z" /></svg>
              <div id='msisdn-input' className={`input ${warning ? 'vibrate' : ''}`}>
                <div className='phone-logo'>
                  <img fetchpriority='high' alt='' src='/phone.avif' />
                </div>
                <input type='tel' value={msisdn} placeholder='5X XXX XXXX' autoComplete='off' minLength={9} maxLength={9} required onChange={handleMsisdnChange} />
              </div>
              <svg fill="#4CA1DF" height="2rem" width="2rem" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 400.004 400.004" xmlSpace="preserve"><g><path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /></g></svg>
            </div> :
            <div className='otp-box'>
              <svg fill="#4CA1DF" height="2rem" width="2rem" viewBox="0 0 330 330" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"><path d="M15,180h263.787l-49.394,49.394c-5.858,5.857-5.858,15.355,0,21.213C232.322,253.535,236.161,255,240,255 s7.678-1.465,10.606-4.394l75-75c5.858-5.857,5.858-15.355,0-21.213l-75-75c-5.857-5.857-15.355-5.857-21.213,0 c-5.858,5.857-5.858,15.355,0,21.213L278.787,150H15c-8.284,0-15,6.716-15,15S6.716,180,15,180z" /></svg>
              <div id='otp-input' className={`input ${warning ? 'vibrate' : ''}`}>
                <input type='tel' value={otp} placeholder='XX XX XX' autoComplete='off' minLength={6} maxLength={6} required onChange={handleOtpChange} ref={otpBoxRef} />
              </div>
              <svg fill="#4CA1DF" height="2rem" width="2rem" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 400.004 400.004" xmlSpace="preserve"><g><path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /></g></svg>
            </div>}

          <div className='button'>
            {firstStep ? <button id='send-otp' onClick={e => { handleSendOtpClick(operator) }}>{language === 'EN' ? 'CONTINUE' : 'اكمل'}</button> : <button id='verify-otp' onClick={handleVerifyOtpClick}>{language === 'EN' ? 'Activate' : 'فعل'}</button>}
          </div>

          <div className='result'>
            <span id='result-value'></span>
          </div>
        </div>

        {isInputBoxPopupVisible && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              padding: '20px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              background: '#fff'
            }}
          >
            <div id='popup-input-form' className='input-form' style={{ color: 'black' }}>
              <h5>{firstStep ? (language === 'EN' ? 'Receive Your Activation Code By SMS' : 'احصل على رمز التفعيل الخاص بك عبر الرسائل القصيرة') : (language === 'EN' ? 'Enter PIN Code' : 'أدخل رمز PIN')}</h5>

              {firstStep ?
                <div className='input-box'>
                  <svg fill="#4CA1DF" height="2rem" width="2rem" viewBox="0 0 330 330" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"><path d="M15,180h263.787l-49.394,49.394c-5.858,5.857-5.858,15.355,0,21.213C232.322,253.535,236.161,255,240,255 s7.678-1.465,10.606-4.394l75-75c5.858-5.857,5.858-15.355,0-21.213l-75-75c-5.857-5.857-15.355-5.857-21.213,0 c-5.858,5.857-5.858,15.355,0,21.213L278.787,150H15c-8.284,0-15,6.716-15,15S6.716,180,15,180z" /></svg>
                  <div id='popup-msisdn-input' className={`input ${warning ? 'vibrate' : ''}`}>
                    <div className='phone-logo'>
                      <img fetchpriority='high' alt='' src='/phone.avif' />
                    </div>
                    <input type='tel' value={msisdn} placeholder='5X XXX XXXX' autoComplete='off' minLength={9} maxLength={9} required onChange={handleMsisdnChange} />
                  </div>
                  <svg fill="#4CA1DF" height="2rem" width="2rem" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 400.004 400.004" xmlSpace="preserve"><g><path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /></g></svg>
                </div> :
                <div className='otp-box'>
                  <svg fill="#4CA1DF" height="2rem" width="2rem" viewBox="0 0 330 330" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"><path d="M15,180h263.787l-49.394,49.394c-5.858,5.857-5.858,15.355,0,21.213C232.322,253.535,236.161,255,240,255 s7.678-1.465,10.606-4.394l75-75c5.858-5.857,5.858-15.355,0-21.213l-75-75c-5.857-5.857-15.355-5.857-21.213,0 c-5.858,5.857-5.858,15.355,0,21.213L278.787,150H15c-8.284,0-15,6.716-15,15S6.716,180,15,180z" /></svg>
                  <div id='popup-otp-input' className={`input ${warning ? 'vibrate' : ''}`}>
                    <input type='tel' value={otp} placeholder='XX XX XX' autoComplete='off' minLength={6} maxLength={6} required onChange={handleOtpChange} ref={popupOtpBoxRef} />
                  </div>
                  <svg fill="#4CA1DF" height="2rem" width="2rem" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 400.004 400.004" xmlSpace="preserve"><g><path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /></g></svg>
                </div>}

              <div className='button'>
                {firstStep ? <button id='popup-send-otp' onClick={e => { handleSendOtpClick(operator) }}>{language === 'EN' ? 'CONTINUE' : 'اكمل'}</button> : <button id='popup-verify-otp' onClick={handleVerifyOtpClick}>{language === 'EN' ? 'Activate' : 'فعل'}</button>}
              </div>

              <div className='result'>
                <span id='popup-result-value'></span>
              </div>
            </div>
          </div>
        )}

        <div id='footer' className='footer'>
          <div className='legacy'>
            {language === 'EN' ? <ul className='en'>
              <li>Kid Security is a subscription service available for Mobily Subscribers the service price is 1.15 Riyal daily with a 1-day free trial for the first subscription(VAT Included). </li>
              <li>VAT Tax was already paid with a refill card for prepaid subscribers. and to unsubscribe send U 58 to 607110</li>
            </ul> : <ul className='ar'>
              <li>امان الأطفال هي خدمة اشتراك متوفرة لمشتركين موبايلي سعر الخدمة ١.٥١ ريال يوميا مع تجربة مجانية ليوم واحد عند اشتراكك اول مره (شامل قيمة الضريبة المضافة).</li>
              <li>تم تحصيل مبلغ الضريبة لعملاء مسبق الدفع عند عملية شحن الرصيد. ولإلغاء * * .الاشتراك أرسل غ ٥٨ إلى 607110</li>
            </ul>}
          </div>
          <div class="link">
            <ul>
              <li><a href='#' onClick={() => nav(`/aa4523/terms?lang=${language}`)}>{language === 'EN' ? 'Terms of Service' : 'شروط الخدمة'}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PinPage;
